import {
    useDeregisterAvisoObraMutation,
    useExtendAvisoObraMutation,
    useRestartAvisoObraMutation,
    useSuspendAvisoObraMutation,
    useUpdateAvisoObraMutation,
    useGenerateNoObraPdfMutation,
    useGenerateConstanciaPdfMutation
} from '../../../services/avisoObraApi';

const useAvisoObraActions = () => {
    const [deregisterAvisoObra, { isLoading: isDeregisteringAvisoObra }] =
        useDeregisterAvisoObraMutation();
    const [suspendAvisoObra, { isLoading: isSuspendingAvisoObra }] = useSuspendAvisoObraMutation();
    const [extendAvisoObra, { isLoading: isExtendingAvisoObra }] = useExtendAvisoObraMutation();
    const [restartAvisoObra, { isLoading: isRestartingAvisoObra }] = useRestartAvisoObraMutation();
    const [updateAvisoObra, { isLoading: isUpdatingPrograma }] = useUpdateAvisoObraMutation();
    const [generateNoObraPdf, { isLoading: isGeneratingNoObraPdf }] =
        useGenerateNoObraPdfMutation();
    const [generateConstanciaPdf, { isLoading: isGeneratingConstanciaPdf }] =
        useGenerateConstanciaPdfMutation();
    return {
        suspendAvisoObra,
        extendAvisoObra,
        restartAvisoObra,
        deregisterAvisoObra,
        updateAvisoObra,
        generateNoObraPdf,
        generateConstanciaPdf,
        isSuspendingAvisoObra,
        isExtendingAvisoObra,
        isRestartingAvisoObra,
        isDeregisteringAvisoObra,
        isUpdatingPrograma,
        isGeneratingNoObraPdf,
        isGeneratingConstanciaPdf
    };
};

export default useAvisoObraActions;
